(ns app.front.view.group.admin.standard-texts.core
  (:require [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.standard-texts.model-codes :as st-model-codes]
            [app.front.view.group.admin.standard-texts.model-codes-download :as st-model-codes-dl]
            [app.front.view.group.admin.standard-texts.model-codes-migrate :as st-model-codes-migrate]
            [app.front.view.group.admin.standard-texts.phrases :as st-phrases]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.model-codes.common :as model-codes-common]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]))

(defn view [match]
  (let [group-id (<sub [::gas/group-id])
        tabs     (concat [[:standard-texts.tabs/phrases st-phrases/section]]
                         (when (<sub [::gas/has-feature? :group.feature/model-codes-integration])
                           [[:standard-texts.tabs/model-codes
                             st-model-codes/section
                             #(>evt [::model-codes-common/init group-id])]
                            [:standard-texts.tabs/model-codes-download
                             st-model-codes-dl/section
                             #(>evt [::st-model-codes-dl/init group-id])]
                            [:standard-texts.tabs/model-codes-migrate
                             st-model-codes-migrate/section
                             #(>evt [::st-model-codes-migrate/init group-id])]]))]
    [acommon/admin-page-v2 (util/mmap {:wait-for-group? true}
                                      match tabs)]))

(def route
  (acommon/standard-route-definition {:name :view/group.admin.standard-texts
                                      :view view}))
